import { Popper } from '@maxroll-media-group/common-libs'
import classNames from 'classnames'
import { HTMLAttributes, ReactNode, useState } from 'react'
import './helper-tooltip.scss'

export function HelperTooltip({
  tooltip,
  children,
  className
}: { tooltip?: ReactNode } & HTMLAttributes<HTMLDivElement>) {
  const [referenceElement, setReferenceElement] = useState<any>(null)
  const [isTooltipVisible, setIsTooltipVisible] = useState(false)

  return (
    <span className={classNames('poe-helper-tooltip-wrapper', className)}>
      <span
        ref={setReferenceElement}
        className={classNames(!children && 'poe-helper-tooltip-icon')}
        onMouseEnter={() => {
          setIsTooltipVisible(true)
        }}
        onMouseLeave={() => {
          setIsTooltipVisible(false)
        }}>
        {children ? children : '?'}
      </span>

      <Popper
        referenceElement={referenceElement}
        visible={isTooltipVisible}
        options={{
          placement: 'right',
          modifiers: [
            { name: 'offset', options: { offset: [0, 10] } },
            {
              name: 'flip',
              options: {
                fallbackPlacements: ['left', 'bottom', 'top']
              }
            },
            {
              name: 'preventOverflow'
            }
          ]
        }}>
        <div className="poe-helper-tooltip-popup-wrapper">{tooltip}</div>
      </Popper>
    </span>
  )
}
